import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
// import { environment } from 'src/environments/environment';
import { AppTokenHandler } from '../CommonService/app-token-handler';
import { DataService } from '../CommonService/data.service';
//import { ConfigService } from '../CommonService/ConfigService';
import { environment } from 'src/environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


const APIEndpoint = environment.serviceBaseUrl;
@Injectable({
  providedIn: 'root'
})


export class CommonService {
  private httpDataServiceOptions: any;
  private httpHeaderFileUpload: any;
  APIEndpoint :string = '';
  constructor(private _data: DataService, private _router: Router,
              private http: HttpClient,
             // private config: ConfigService,
              private appToken: AppTokenHandler,
              private httpClient: HttpClient) { 
                this.APIEndpoint = environment.serviceBaseUrl;
              }

              PostService(param: any, apiUrl: string): any {
                this.httpDataServiceOptions = {
                    headers: new HttpHeaders({
                        'AUTHA': this.appToken.getSessionToken(),
                        'Content-Type': 'application/json'
                    }),
                    withCredentials: true
                };
                //this.APIEndpoint = this.config.settings.serviceBaseUrl;
                return this.httpClient.post(this.APIEndpoint + apiUrl, param, this.httpDataServiceOptions)
                    .pipe(map(data => data));
            }

  GetRestItems(apiUrl: string) {
    this.httpDataServiceOptions = {
      headers: new HttpHeaders({
        'AUTHA': this.appToken.getSessionToken(),
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    };
    //this.APIEndpoint = this.config.settings.serviceBaseUrl;
    return this.httpClient
      .get(this.APIEndpoint + apiUrl, this.httpDataServiceOptions)
      .pipe(map(data => data));
  }
  

  GetAllUnAdjustedData = (data: any): any => {
    return this._data.PostData('UnadjustedAdvance/GetMailStatusForUnAdjustedAdvance', data);
}
ExecuteUnadjustedAdvanceMailers = (data:any):any => {
  return this._data.PostData('UnadjustedAdvance/ExecuteUnadjustedAdvanceMailers' , data);

}

  PostFormData(param: any, apiUrl: string): any {
    this.httpHeaderFileUpload = {
        headers: new HttpHeaders({
            'AUTHA': this.appToken.getSessionToken()
        }),
        withCredentials: true
    };
    //this.APIEndpoint = this.config.settings.serviceBaseUrl;
    return this.httpClient.post(this.APIEndpoint + apiUrl, param, this.httpHeaderFileUpload)
        .pipe(map(data => data));
}

getAuditTrails = (id: string, className: string): any => {
  if (id != null) {
      return this._data.get('FillData/GetAuditTrails/' + id + '/' + className, null, null);
  } else {
  }
}

getClauseDetailAuditTrail = (clauseGTCID : number): any => {
  return this._data.GetData('TaxGTC/GetClauseDetailAuditTrailById/' + clauseGTCID);
}
BindDropDown(DropDownName: any) {
  return this._data.create('FillData/BindDropDown', { Param1: DropDownName });
}

BindDropDownForPaceValues(SearchValue: any) {
  return this._data.create('FillData/BindPaceValues', { Param1: SearchValue });
}

BindDropDownForEmpValues(SearchValue: any) {
  return this._data.create('FillData/BindEmpValues', { Param1: SearchValue , Param2: 'RoleAssignment'});
}

BindDropDownForEmpPartnerValues(SearchValue: any) {
  return this._data.create('FillData/BindEmpValues', { Param1: SearchValue , Param2: 'Partner'});
}

BindDropDownForEmpManagerValues(SearchValue: any) {
  return this._data.create('FillData/BindEmpValues', { Param1: SearchValue , Param2: 'Manager'});
}

BindDropDownWithParam(DropDownName: any, Param = '', Param1 = null) {
  return this._data.create('FillData/BindDropDown', { Param1: DropDownName, Param2: Param, Param3: Param1 });
}

BindEntityDropDownWithParam(DropDownName: any, Param = null, Param1 = null, Param2 = null) {
  return this._data.create('FillData/BindDropDown', { Param1: DropDownName, Param2: Param, Param3: Param1, Param4: Param });
}

}
